var map = {
	"./help/help.module.ngfactory": [
		"./src/app/pages/help/help.module.ngfactory.js",
		"help-help-module-ngfactory"
	],
	"./legally/legal.module.ngfactory": [
		"./src/app/pages/legally/legal.module.ngfactory.js",
		"legally-legal-module-ngfactory"
	],
	"./projects/projects.module.ngfactory": [
		"./src/app/pages/projects/projects.module.ngfactory.js",
		"default~app-pages-pages-module-ngfactory~projects-projects-module-ngfactory",
		"projects-projects-module-ngfactory"
	],
	"./users/users.module.ngfactory": [
		"./src/app/pages/users/users.module.ngfactory.js",
		"users-users-module-ngfactory"
	],
	"app/pages/pages.module.ngfactory": [
		"./src/app/pages/pages.module.ngfactory.js",
		"default~app-pages-pages-module-ngfactory~projects-projects-module-ngfactory",
		"app-pages-pages-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;